import { Observable, combineLatest, forkJoin, of } from "rxjs";

export function safeCombineLatest<T>(observables: Observable<T>[] | null | undefined) {
	let obs = observables ? observables : [];
	
	return obs.length === 0 ? of([]) : combineLatest(obs);
};

export function safeForkJoin<T>(observables: Observable<T>[] | null | undefined) {
	let obs = observables ? observables : [];
	
	return obs.length === 0 ? of([]) : forkJoin(obs);
};